import { UntypedFormControl } from '@angular/forms';

export class ErrorDefinition {
  constructor(
    public key: string,
    public showFunction: () => boolean,
    public errorMessage: (formControl: UntypedFormControl) => string,
  ) {}
}
